<ion-item>

  <ion-thumbnail slot="start">
    <img [src]="image || 'assets/img/empty-img/no_image.png'" alt=""/>
  </ion-thumbnail>

  <ion-label>
    <p class="title">{{ title }}</p>

    @if (format) {
      <p class="description">{{ format }}</p>
    }
  </ion-label>

  @if (cost && permissionsManager.checkPermission('precios', 'ver')) {
    <ion-note slot="end">
      <p class="cost">
         <span [ngClass]="{'discount line': !!discount}">
            {{ cost ? (cost | currency: 'EUR': 'symbol': '1.2-2': 'es') : '--' }}
         </span>

        @if (discount) {
          <span>
            {{ finalCost ? (finalCost | currency: 'EUR': 'symbol': '1.2-2': 'es') : '--' }}
          </span>
        }
      </p>

      @if (discount) {
        <p class="discount">{{ discount }}% Dto.</p>
      }
    </ion-note>
  }

</ion-item>
